import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 21l18 -18","key":"svg-0"}],["path",{"d":"M4 12a8 8 0 1 0 16 0a8 8 0 1 0 -16 0","key":"svg-1"}]]

const IconMathAvg = createReactComponent('outline', 'math-avg', 'MathAvg', __iconNode);

export default IconMathAvg;